import { SessionStates } from "./SessionModel";
import { Moment } from "moment-timezone";
import CalendarScheduleCandidate from "./CalendarScheduleCandidate";
import CandidateModel from "./CandidateModel";
import ScheduleSlotModel from "./ScheduleSlotModel";
import StudentModel from "./StudentModel";
import TutorModel from "./TutorModel";

export default class RequestsModel {
  user?: TutorModel | StudentModel | CandidateModel | null;
  slots: Array<any>;
  createdAt: Moment;
  status?: string;
  id: number | string;
  cancellationReason?: string;
  scheduleSlot: any;
  userType?: string;
  recitationScheduleSlots?: Array<any>;
  date?: any;
  sessionNumber?: string | number;
  constructor(arg: any) {
    if (!!arg.tutor) {
      this.user = TutorModel.fromApiResponse(arg.tutor);
      this.userType = "tutor";
    }
    if (!!arg.student) {
      this.user = StudentModel.fromApiResponse(arg.student);
      this.userType = "student";
    }
    if (!!arg.candidate) {
      this.user = CandidateModel.fromApiResponse(arg.candidate);
      this.userType = "candidate";
    }
    if (!!arg.sender) this.user = TutorModel.fromApiResponse(arg.sender);
    if (!!arg.receiver) this.user = StudentModel.fromApiResponse(arg.receiver);
    this.date = arg?.date;
    this.slots = arg?.schedule?.schedule_slots;
    this.sessionNumber = arg?.session_number;
    this.cancellationReason = arg.cancellation_reason;
    this.createdAt = arg.created_at;
    this.scheduleSlot = arg.schedule_slot;
    this.recitationScheduleSlots =
      arg?.recitation_schedule_slots?.schedule_slots ??
      arg?.schedule?.recitation_schedule_slots?.schedule_slots;

    this.id = arg.id;
    this.status = arg.status;
  }

  static fromApiResponse(data: any, type: string): any {
    if (Array.isArray(data)) {
      if (data.length > 0) {
        return data
          .map((val: any) => {
            delete val[type];
            return new this(val);
          })
          .filter((notUndefined) => notUndefined !== undefined);
      } else {
        return [];
      }
    } else if (!!data) {
      return new this(data);
    }
    return [];
  }
  static fromApiResponsePending(data: any, type: string): any {
    if (Array.isArray(data)) {
      if (data.length > 0) {
        return data
          .map((val: any) => {
            if (val.status === "pending") {
              delete val[type];
              return new this(val);
            }
          })
          .filter((notUndefined) => notUndefined !== undefined);
      } else {
        return [];
      }
    } else if (!!data) {
      return new this(data);
    }
    return [];
  }
  static fromApiResponseWithoutPending(data: any, type: string): any {
    if (Array.isArray(data)) {
      if (data.length > 0) {
        return data
          .map((val: any) => {
            if (val.status !== "pending" && !!val?.scheduleSlot) {
              delete val[type];
              return new this(val);
            } else if (val?.cancellation_reason && val.status !== "pending") {
              delete val[type];
              return new this(val);
            }
          })
          .filter((notUndefined) => notUndefined !== undefined);
      } else {
        return [];
      }
    } else if (!!data) {
      return new this(data);
    }
    return [];
  }
}
